import { setupFormState } from '@/components/form/tidal-form'
import { ExecutionEventsFormValues } from './typings'

export const form = setupFormState<ExecutionEventsFormValues>({
  id: 'executionEventsForm',
  initialValues: {
    timeInSec: -1,
    timeInLatLng: undefined,
    timeOutSec: -1,
    timeOutLatLng: undefined,
    status: 'missing',
    statusSec: -1,
    statusLatLng: undefined,
    autoTimeInSec: -1,
    autoTimeInLatLng: undefined,
    autoTimeOutSec: -1,
    autoTimeOutLatLng: undefined,
    isEmpty: true,
    statusReason: '',
    latestTrackedLoadLatLng: null,
    latestTrackedLoadSec: -1,
    pods: {
      signatures: undefined,
      pictures: undefined,
      audios: undefined,
      barcodes: [],
      driverBarcodes: [],
      note: {
        podType: 'note',
        uuid: 'EMPTY_NOTE_UUID',
        sec: -1,
        latLng: null,
        text: '',
      },
    },
    dynamicLoads: {},
    customFields: {},
    formPods: {
      pictures: [],
      signatures: [],
      note: '',
      audios: [],
      barcodes: [],
      driverBarcodes: [],
    },
  },
})
